import { render, staticRenderFns } from "./CreateLostAndFound.vue?vue&type=template&id=30fb30a8&scoped=true"
import script from "./CreateLostAndFound.vue?vue&type=script&lang=js"
export * from "./CreateLostAndFound.vue?vue&type=script&lang=js"
import style0 from "./CreateLostAndFound.vue?vue&type=style&index=0&id=30fb30a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fb30a8",
  null
  
)

export default component.exports